import { useContext } from "react";
import Drawer from "../../drawer/Drawer.jsx";
import CustomButton from "../../kits/custom-button/CustomButton";
import colorSchema from "../../../assets/kits/colors";
import useAxios from "../../../services/useAxios";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext";
import ShoppingCartItemContext from "../../../context/ShoppingCart/ShoppingCartItemContext.tsx";

export default function DeleteCartItemDrawer({
  isOpen,
  setIsOpen,
  supplierId
}) {
  const auth = useContext(AuthenticationContext);
  const { updateShoppingList } = useContext(ShoppingCartItemContext);

  const { execute: deleteCartItem } = useAxios("api/delete_cart");
  const deleteCart = () => {
    deleteCartItem({
      user_id: auth.userInfo.id,
      supplier_id: supplierId
    }).then(data => {
      if (data.status == 1) {
        setIsOpen(false);
      }
    });
  };
  {
    /* delete cartitem drawer*/
  }
  return (
    <Drawer isOpen={isOpen} height={178} onClose={() => setIsOpen(false)}>
      <div>
        <h3
          className="title-h3-b mr-r-20 mr-t-16"
          style={{ color: colorSchema.foreground_background_he }}
        >
          حذف سبد خرید
        </h3>
        <p
          className="desc-c-l mr-t-16 mr-x-20"
          style={{ color: colorSchema.foreground_background_he }}
        >
          آیا می خواهید سبد خرید خود را حذف کنید؟
        </p>
        <div className="d-flex mr-x-20 mr-t-20">
          <CustomButton
            style={{ width: "50%", height: 48 }}
            buttonStyle="primary"
            size="large"
            onClick={() => {
              deleteCart();
              updateShoppingList();
            }}
          >
            بله
          </CustomButton>
          <CustomButton
            style={{ width: "50%", height: 48 }}
            buttonStyle="text"
            size="large"
            onClick={() => setIsOpen(false)}
          >
            خیر
          </CustomButton>
        </div>
      </div>
    </Drawer>
  );
}
